import { render, staticRenderFns } from "./SampleDocuments.vue?vue&type=template&id=79614081&"
import script from "./SampleDocuments.vue?vue&type=script&lang=js&"
export * from "./SampleDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports